const isValidCheckoutQuery = (query) => {
  return query.adults && query.babies != undefined && query.childs != undefined && query.destino && query.fecha && query.origen;
}

export default isValidCheckoutQuery;

